import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { FACILITY_USER_ACCESS_MODE } from '@/constants/facilityUserAccessModes';

const ACCESS_MODE_CONFIG = {
  [FACILITY_USER_ACCESS_MODE.ALL_FACILITIES]: {
    color: 'primary',
    translationKey: 'facilityUserManagement.access.allFacilities',
    fallback: 'All Facilities',
  },
  [FACILITY_USER_ACCESS_MODE.FACILITY_GROUPS]: {
    color: 'secondary',
    translationKey: 'facilityUserManagement.access.facilityGroups',
    fallback: 'Facility Groups',
  },
  [FACILITY_USER_ACCESS_MODE.DIRECT_FACILITIES]: {
    color: 'info',
    translationKey: 'facilityUserManagement.access.directFacilities',
    fallback: 'Direct Facilities',
  },
  [FACILITY_USER_ACCESS_MODE.NONE]: {
    color: 'default',
    translationKey: 'facilityUserManagement.access.none',
    fallback: 'No Access',
  },
};

const FacilityUserAccessModeChip = ({ accessMode }) => {
  const { t } = useTranslation();
  const config =
    ACCESS_MODE_CONFIG[accessMode] ||
    ACCESS_MODE_CONFIG[FACILITY_USER_ACCESS_MODE.NONE];

  return (
    <Chip
      label={t(config.translationKey, config.fallback)}
      color={config.color}
      size='small'
      variant='outlined'
    />
  );
};

export default FacilityUserAccessModeChip;
